import Link from "./Link";
import LinkWithRef from "./LinkWithRef";

export default Link;
export { LinkWithRef };
